/**
 * Converts back and forth between hex SMPTE Universal Labels (UL), symbolic
 * names and MXF static local tags.
 *
 * Also provides categorization based on subsets of the symbolic names.
 */

export const SMPTE_UL_STRING_LENGTH = (16 * 3) - 1;
export const SMPTE_UL_INDEX_TABLE_SEGMENT = '06.0e.2b.34.02.53.01.01.0d.01.02.01.01.10.01.00';

export const SMPTE_UL_KLV_FILL =            '06.0e.2b.34.01.01.01.02.03.01.02.10.01.00.00.00';
export const SMPTE_UL_KLV_FILL_LEGACY =     '06.0e.2b.34.01.01.01.01.03.01.02.10.01.00.00.00';

export const SMPTE_UL_KLV_FILLS = new Set([
  SMPTE_UL_KLV_FILL,
  SMPTE_UL_KLV_FILL_LEGACY,
]);

// Table 4 – Partition Pack Key Value
// Table 6 – Specification of the Header Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.02.00';
export const SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION =     '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.03.00';
export const SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.02.04.00';

// Table 4 – Partition Pack Key Value
// Table 7 – Specification of the Body Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.02.00';
export const SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION =     '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.03.00';
export const SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION =   '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.03.04.00';

// Table 4 – Partition Pack Key Value
// Table 8 – Specification of the Footer Partition Pack Key
export const SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION =    '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.01.00';
export const SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION =  '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.02.00';
export const SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION =      '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.03.00';
export const SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION =    '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.04.04.00';

export const SMPTE_UL_RANDOM_INDEX_PACK = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.11.01.00';

export const SMPTE_UL_PARTITION_PACKS = new Set([
  SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION,
  SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION,
  SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION,
  SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION,
  SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION,
  SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION,
  SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION,
  SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION,
]);

export const SMPTE_UL_PRIMER_PACK = '06.0e.2b.34.02.05.01.01.0d.01.02.01.01.05.01.00';

export const SMPTE_PICTURE_ESSENCE_CODING_AVC_BASELINE =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.11.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_MAIN =                                       '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.20.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_EXTENDED =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.30.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH =                                       '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.40.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10 =                                    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.50.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422 =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.60.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444 =                                   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.31.70.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA =                              '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.20.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_5994I =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_50I =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.02';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_2997P =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.03';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_25P =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.04';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_5994P =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.08';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_50P =     '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.21.09';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA =                             '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.30.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_5994I = '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_50I =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.02';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_2997P = '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.03';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_25P =   '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.04';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_5994P =  '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.08';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_50P =    '06.0e.2b.34.04.01.01.0a.04.01.02.02.01.32.31.09';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444_INTRA =                             '06.0e.2b.34.04.01.01.0d.04.01.02.02.01.32.40.01';
export const SMPTE_PICTURE_ESSENCE_CODING_AVC_CAVLC_444 =                                  '06.0e.2b.34.04.01.01.0d.04.01.02.02.01.32.50.01';

export const SMPTE_UL_ESSENCE_ELEMENT_PREFIX = '06.0e.2b.34.01.02.01.01.0d.01.03.01.';

// First 13 bytes are defined by: SMPTE-379M-2004: Table 1
// Last 3 bytes are defined by: SMPTE-394M-2006: Table 2
export const SMPTE_UL_SYSTEM_SCHEME_1 = '06.0e.2b.34.02.53.01.01.0d.01.03.01.14.02.01.00';

// SMPTE ST 385:2012: Table 1
export const SMPTE_UL_SDTI_SYSTEM_METADATA = '06.0e.2b.34.02.05.01.01.0d.01.03.01.04.01.01.00';

export function isEssenceElement(ul: string): boolean {
  return (ul.length === SMPTE_UL_STRING_LENGTH) && ul.startsWith(SMPTE_UL_ESSENCE_ELEMENT_PREFIX);
}

export function extractEssenceTrack(ul: string): string | null {
  if ((ul.length === SMPTE_UL_STRING_LENGTH) && ul.startsWith(SMPTE_UL_ESSENCE_ELEMENT_PREFIX)) {
    return ul.slice(SMPTE_UL_ESSENCE_ELEMENT_PREFIX.length);
  } else {
    return null;
  }
}

export function isStructuralMetadataSet(ul: string): boolean {
  // Table 16 – Common Key Value for the Structural Metadata Sets
  const pattern : RegExp = /^06\.0e\.2b\.34\.02\.[0-9a-z]{2}\.01\.[0-9a-z]{2}\.0d\.01\.01\.01\.01\.[0-9a-z]{2}\.[0-9a-z]{2}\.00$/;
  return pattern.exec(ul) !== null;
}

export class MxfDictionary {
  private ulToName: Record<string, string> = {};
  private nameToUl: Record<string, string> = {};
  private ulToTag: Record<string, string> = {};
  private tagToUl: Record<string, string> = {};

  public constructor() {
    for (const name in DEFAULT_NAME_TO_UL) {
      const ul = DEFAULT_NAME_TO_UL[name];
      this.add(name, ul!);
    }
    for (const localTag in INDEX_TABLE_STATIC_TAGS) {
      const ul = INDEX_TABLE_STATIC_TAGS[localTag];
      this.addLocalTag(localTag, ul!);
    }
  }

  public add(name: string, ul: string) {
    this.nameToUl[name] = ul;
    this.ulToName[ul] = name;
  }

  public getName(ul: string): string | undefined {
    return this.ulToName[ul];
  }

  public getUl(name: string): string | undefined {
    return this.nameToUl[name];
  }

  public addLocalTag(localTag: string, ul: string) {
    this.tagToUl[localTag] = ul;
    this.ulToTag[ul] = localTag;
  }

  public getUlFromLocalTag(localTag: string): string | undefined {
    return this.tagToUl[localTag];
  }

  public getLocalTagFromUl(ul: string): string | undefined {
    return this.ulToTag[ul];
  }
}

// This dictionary has been extracted from SMPTE 377-1-2009. This is not
// complete has only been extended when a key is needed.
// References:
// * https://web.archive.org/web/20231212154231/https://raw.githubusercontent.com/juliusfriedman/net7mma/master/Reference/MXF-S377-1-2009.pdf

const DEFAULT_NAME_TO_UL : Record<string, string> = {
  'OpenAndIncompleteHeaderPartition'   : SMPTE_UL_OPEN_AND_INCOMPLETE_HEADER_PARTITION,
  'ClosedAndIncompleteHeaderPartition' : SMPTE_UL_CLOSED_AND_INCOMPLETE_HEADER_PARTITION,
  'OpenAndCompleteHeaderPartition'     : SMPTE_UL_OPEN_AND_COMPELTE_HEADER_PARTITION,
  'ClosedAndCompleteHeaderPartition'   : SMPTE_UL_CLOSED_AND_COMPELTE_HEADER_PARTITION,

  'OpenAndIncompleteBodyPartition'     : SMPTE_UL_OPEN_AND_INCOMPLETE_BODY_PARTITION,
  'ClosedAndIncompleteBodyPartition'   : SMPTE_UL_CLOSED_AND_INCOMPLETE_BODY_PARTITION,
  'OpenAndCompleteBodyPartition'       : SMPTE_UL_OPEN_AND_COMPLETE_BODY_PARTITION,
  'ClosedAndCompleteBodyPartition'     : SMPTE_UL_CLOSED_AND_COMPLETE_BODY_PARTITION,

  'OpenAndIncompleteFooterPartition'   : SMPTE_UL_OPEN_AND_INCOMPLETE_FOOTER_PARTITION,
  'ClosedAndIncompleteFooterPartition' : SMPTE_UL_CLOSED_AND_INCOMPLETE_FOOTER_PARTITION,
  'OpenAndCompleteFooterPartition'     : SMPTE_UL_OPEN_AND_COMPLETE_FOOTER_PARTITION,
  'ClosedAndCompleteFooterPartition'   : SMPTE_UL_CLOSED_AND_COMPLETE_FOOTER_PARTITION,

  // Table 13 – Primer Pack Key Value
  'PrimerPack'                         : SMPTE_UL_PRIMER_PACK,

  // 6.3.3 KLV Fill Items
  'KLVFill'                            : SMPTE_UL_KLV_FILL,
  'KLVFill(legacy)'                    : SMPTE_UL_KLV_FILL_LEGACY,

  // Table 16: Common Key Value for the Structural Metadata Sets
  // Table 17: Key Values for Structural Metadata Sets
  'Preface'                            : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.2f.00',
  'Identification'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.30.00',
  'ContentStorage'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.18.00',
  'EssenceContainerData'               : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.23.00',
  'MaterialPackage'                    : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.36.00',
  'SourcePackage'                      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.37.00',
  'TimelineTrack'                      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.3b.00',
  'EventTrack'                         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.39.00',
  'StaticTrack'                        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.3a.00',
  'Sequence'                           : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.0f.00',
  'SourceClip'                         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.11.00',
  'TimecodeComponent'                  : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.14.00',
  'DMSegment'                          : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.41.00',
  'DMSourceClip'                       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.45.00',
  'Filler'                             : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.09.00',
  'PackageMarkerObject'                : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.60.00',
  'FileDescriptor'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.25.00',
  'GenericPictureEssenceDescriptor'    : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.27.00',
  'ContainerDuration'                  : '06.0e.2b.34.01.01.01.01.04.06.01.02.00.00.00.00',
  'CDCIEssenceDescriptor'              : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.28.00',
  'RGBAEssenceDescriptor'              : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.29.00',
  'GenericSoundEssenceDescriptor'      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.42.00',
  'GenericDataEssenceDescriptor'       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.43.00',
  'MultipleDescriptor'                 : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.44.00',
  'NetworkLocator'                     : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.32.00',
  'TextLocator'                        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.33.00',
  'ApplicationPluginObject'            : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.61.00',
  'ApplicationReferencedObject'        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.62.00',

  // Annex A.2 - Preface
  'ContentStorageRef'                  : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.01.00.00',

  // Annex A.4 - Content Storage
  'Packages'                           : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.01.00.00',

  // Annex B.1 - Generic Package
  'PackageUID'                         : '06.0e.2b.34.01.01.01.01.01.01.15.10.00.00.00.00',
  'PackageCreationDate'                : '06.0e.2b.34.01.01.01.02.07.02.01.10.01.03.00.00',
  'PackageModifiedDate'                : '06.0e.2b.34.01.01.01.02.07.02.01.10.02.05.00.00',
  'Tracks'                             : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.05.00.00',

  // Annex B.6
  'TrackID'                            : '06.0e.2b.34.01.01.01.02.01.07.01.01.00.00.00.00',
  'TrackNumber'                        : '06.0e.2b.34.01.01.01.02.01.04.01.03.00.00.00.00',
  'TrackName'                          : '06.0e.2b.34.01.01.01.02.01.07.01.02.01.00.00.00',
  'SequenceRef'                        : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.04.00.00',

  // Annex B.8 - Structural Component
  'DataDefinition'                     : '06.0e.2b.34.01.01.01.02.04.07.01.00.00.00.00.00',
  'Duration'                           : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.03.00.00',

  // Annex B.9 - Sequence
  'StructuralComponents'               : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.09.00.00',

  // Annex B.12 - Timeline Track
  'EditRate'                           : '06.0e.2b.34.01.01.01.02.05.30.04.05.00.00.00.00',
  'Origin'                             : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.03.00.00',

  // Annex B.17 - Timecode component
  'StartTimecode'                      : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.05.00.00',
  'RoundedTimecodeBase'                : '06.0e.2b.34.01.01.01.02.04.04.01.01.02.06.00.00',
  'DropFrame'                          : '06.0e.2b.34.01.01.01.01.04.04.01.01.05.00.00.00',

  // Annex E.2 - Source Package
  'Descriptor'                         : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.03.00.00',

  // Annex F.2 - File descriptor
  'EssenceContainer'                   : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.02.00.00',
  'SampleRate'                         : '06.0e.2b.34.01.01.01.01.04.06.01.01.00.00.00.00',
  'ChannelCount'                       : '06.0e.2b.34.01.01.01.05.04.02.01.01.04.00.00.00',
  'QuantizationBits'                   : '06.0e.2b.34.01.01.01.04.04.02.03.03.04.00.00.00',


  // Annex F.3 - Multiple descriptor
  'SubDescriptors'                     : '06.0e.2b.34.01.01.01.04.06.01.01.04.06.0b.00.00',

  // Annex F.4.1 - Generic Picture Essence Descriptor
  'PictureEssenceCoding'               : '06.0e.2b.34.01.01.01.02.04.01.06.01.00.00.00.00',
  'LinkedTrackID'                      : '06.0e.2b.34.01.01.01.05.06.01.01.03.05.00.00.00',

  // Not sure which standard is supposed to provide these. These where found doing reverse
  // engineering using Nablets MXF analyzer
  'MPEG2PictureEssenceDescriptor'      : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.51.00',
  'CDCIPictureEssenceDescriptor'       : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.28.00',
  'AESAudioEssenceDescriptor'          : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.47.00',
  'WaveAudioEssenceDescriptor'         : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.48.00',
  'ANCPacketsEssenceDescriptor'        : '06.0e.2b.34.02.53.01.01.0d.01.01.01.01.01.5c.00',


  // Table 29 – Random Index Pack Key Value
  'RandomIndexPack'                    : SMPTE_UL_RANDOM_INDEX_PACK,

  // Table 25 – Specification of the Index Table Segment Key
  'IndexTableSegment'                  : SMPTE_UL_INDEX_TABLE_SEGMENT,

  // Table 26 – Index Table Segment Set
  'InstanceUID'                        : '06.0e.2b.34.01.01.01.01.01.01.15.02.00.00.00.00',
  'IndexEditRate'                      : '06.0e.2b.34.01.01.01.05.05.30.04.06.00.00.00.00',
  'IndexStartPosition'                 : '06.0e.2b.34.01.01.01.05.07.02.01.03.01.0a.00.00',
  'IndexDuration'                      : '06.0e.2b.34.01.01.01.05.07.02.02.01.01.02.00.00',
  'EditUnitByteCount'                  : '06.0e.2b.34.01.01.01.04.04.06.02.01.00.00.00.00',
  'IndexSID'                           : '06.0e.2b.34.01.01.01.04.01.03.04.05.00.00.00.00',
  'BodySID'                            : '06.0e.2b.34.01.01.01.04.01.03.04.04.00.00.00.00',
  'SliceCount'                         : '06.0e.2b.34.01.01.01.04.04.04.04.01.01.00.00.00',
  'PosTableCount'                      : '06.0e.2b.34.01.01.01.05.04.04.04.01.07.00.00.00',
  'DeltaEntryArray'                    : '06.0e.2b.34.01.01.01.05.04.04.04.01.06.00.00.00',
  'IndexEntryArray'                    : '06.0e.2b.34.01.01.01.05.04.04.04.02.05.00.00.00',
  'ExtStartOffset'                     : '06.0e.2b.34.01.01.01.0a.04.06.02.04.00.00.00.00',
  'VBEByteCount'                       : '06.0e.2b.34.01.01.01.0a.04.06.02.05.00.00.00.00',

  // Table 27 - Structure of Delta Entry Array
  'PosTableIndex'                      : '06.0e.2b.34.01.01.01.04.04.04.04.01.04.00.00.00',
  'Slice'                              : '06.0e.2b.34.01.01.01.04.04.04.04.01.02.00.00.00',
  'ElementDelta'                       : '06.0e.2b.34.01.01.01.04.04.04.04.01.03.00.00.00',

  // Table 28 – Structure of Index Entry Array
  'TemporalOffset'                     : '06.0e.2b.34.01.01.01.04.04.04.04.02.03.00.00.00',
  'KeyFrameOffset'                     : '06.0e.2b.34.01.01.01.04.04.04.04.02.04.00.00.00',
  'Flags'                              : '06.0e.2b.34.01.01.01.04.04.04.04.02.02.00.00.00',
  'StreamOffset'                       : '06.0e.2b.34.01.01.01.04.04.04.04.02.01.00.00.00',
  'SliceOffset'                        : '06.0e.2b.34.01.01.01.04.04.04.04.01.05.00.00.00',
  'PosTable'                           : '06.0e.2b.34.01.01.01.05.04.04.04.01.08.00.00.00',

  'SystemScheme1'                      : SMPTE_UL_SYSTEM_SCHEME_1,
  'STDISystemMetadata'                 : SMPTE_UL_SDTI_SYSTEM_METADATA,

  // Picture essence codings
  'AVC Baseline'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_BASELINE,
  'AVC Main'                                        : SMPTE_PICTURE_ESSENCE_CODING_AVC_MAIN,
  'AVC Extended'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_EXTENDED,
  'AVC High'                                        : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH,
  'AVC High 10'                                     : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10,
  'AVC High 422'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422,
  'AVC High 444'                                    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444,
  'AVC High 10 Intra'                               : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA,
  'AVC High 10 Intra RP2027 Class 50 1080/59.94i'   : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_5994I,
  'AVC High 10 Intra RP2027 Class 50 1080/50i'      : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_50I,
  'AVC High 10 Intra RP2027 Class 50 1080/29.97p'   : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_2997P,
  'AVC High 10 Intra RP2027 Class 50 1080/25p'      : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_1080_25P,
  'AVC High 10 Intra RP2027 Class 50 720/59.94p'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_5994P,
  'AVC High 10 Intra RP2027 Class 50 720/50p'       : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_10_INTRA_RP2027_CLASS_50R_720_50P,
  'AVC High 422 Intra'                              : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA,
  'AVC High 422 Intra RP2027 Class 100 1080/59.94i' : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_5994I,
  'AVC High 422 Intra RP2027 Class 100 1080/50i'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_50I,
  'AVC High 422 Intra RP2027 Class 100 1080/29.97p' : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_2997P,
  'AVC High 422 Intra RP2027 Class 100 1080/25p'    : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_1080_25P,
  'AVC High 422 Intra RP2027 Class 100 720/59.94p'  : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_5994P,
  'AVC High 422 Intra RP2027 Class 100 720/50p'     : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_422_INTRA_RP2027_CLASS_100_720_50P,
  'AVC High 444 Intra'                              : SMPTE_PICTURE_ESSENCE_CODING_AVC_HIGH_444_INTRA,
  'AVC CAVLC 444'                                   : SMPTE_PICTURE_ESSENCE_CODING_AVC_CAVLC_444,
};

// Summary of 9.2 Primer Pack:
// The Primer pack should only cover local tags for the same header/footer
// partition. Because the body partitions may contain IndexTableSegments and
// the body partitions shall not contain PrimerPack the Primer pack is NOT
// required for parsing the IndexTable. Instead all ULs in the for the fields
// in the index table segment have static hard coded local tags. These are
// defined in:
//
// Annex H (Normative)
// Static Local Tags Assigned by MXF Specifications (subset)
const INDEX_TABLE_STATIC_TAGS : Record<string, string> = {
  '00.01' : '06.0e.2b.34.01.01.01.0a.06.01.01.07.16.00.00.00',
  '00.02' : '06.0e.2b.34.01.01.01.0a.06.01.01.07.17.00.00.00',
  '00.03' : '06.0e.2b.34.01.01.01.02.06.01.01.07.07.00.00.00',
  '00.04' : '06.0e.2b.34.01.01.01.02.06.01.01.07.08.00.00.00',
  '00.05' : '06.0e.2b.34.01.01.01.02.06.01.01.07.13.00.00.00',
  '00.06' : '06.0e.2b.34.01.01.01.02.03.02.04.01.02.01.00.00',
  '00.07' : '06.0e.2b.34.01.01.01.02.06.01.01.07.14.01.00.00',
  '00.08' : '06.0e.2b.34.01.01.01.02.06.01.01.07.01.00.00.00',
  '00.09' : '06.0e.2b.34.01.01.01.02.06.01.01.07.02.00.00.00',
  '00.0a' : '06.0e.2b.34.01.01.01.02.06.01.01.07.03.00.00.00',
  '00.0b' : '06.0e.2b.34.01.01.01.02.06.01.01.07.04.00.00.00',
  '00.0c' : '06.0e.2b.34.01.01.01.02.03.01.02.02.01.00.00.00',
  '00.0d' : '06.0e.2b.34.01.01.01.02.06.01.01.07.05.00.00.00',
  '00.0e' : '06.0e.2b.34.01.01.01.02.06.01.01.07.06.00.00.00',
  '00.0f' : '06.0e.2b.34.01.01.01.02.03.01.02.03.01.00.00.00',
  '00.10' : '06.0e.2b.34.01.01.01.02.03.01.02.03.02.00.00.00',
  '00.11' : '06.0e.2b.34.01.01.01.02.06.01.01.07.09.00.00.00',
  '00.12' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0a.00.00.00',
  '00.13' : '06.0e.2b.34.01.01.01.02.03.01.02.03.0b.00.00.00',
  '00.14' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0b.00.00.00',
  '00.15' : '06.0e.2b.34.01.01.01.02.03.01.02.03.04.00.00.00',
  '00.16' : '06.0e.2b.34.01.01.01.02.03.01.02.03.05.00.00.00',
  '00.17' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0c.00.00.00',
  '00.18' : '06.0e.2b.34.01.01.01.02.03.01.02.03.03.00.00.00',
  '00.19' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0d.00.00.00',
  '00.1a' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0e.00.00.00',
  '00.1b' : '06.0e.2b.34.01.01.01.02.06.01.01.07.0f.00.00.00',
  '00.1c' : '06.0e.2b.34.01.01.01.02.06.01.01.07.11.00.00.00 ',
  '00.1d' : '06.0e.2b.34.01.01.01.02.03.01.02.03.06.00.00.00',
  '00.1e' : '06.0e.2b.34.01.01.01.02.06.01.01.07.12.00.00.00',
  '00.1f' : '06.0e.2b.34.01.01.01.02.03.01.02.03.07.00.00.00',
  '00.20' : '06.0e.2b.34.01.01.01.02.03.01.02.03.08.00.00.00',
  '00.21' : '06.0e.2b.34.01.01.01.0a.06.01.01.07.18.00.00.00',
  '00.22' : '06.0e.2b.34.01.01.01.0a.06.01.01.07.19.00.00.00',
  '01.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.01.00.00',
  '01.02' : '06.0e.2b.34.01.01.01.02.05.20.07.01.08.00.00.00',
  '02.01' : '06.0e.2b.34.01.01.01.02.04.07.01.00.00.00.00.00',
  '02.02' : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.03.00.00',
  '02.03' : '06.0e.2b.34.01.01.01.02.03.01.02.10.04.00.00.00',
  '02.04' : '06.0e.2b.34.01.01.01.07.03.02.01.02.16.00.00.00',
  '02.05' : '06.0e.2b.34.01.01.01.07.03.01.02.10.08.00.00.00',
  '04.01' : '06.0e.2b.34.01.01.01.02.01.04.09.01.00.00.00.00',
  '04.02' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.09.00.00',
  '04.03' : '06.0e.2b.34.01.01.01.01.04.10.01.03.01.02.00.00',
  '04.04' : '06.0e.2b.34.01.01.01.02.01.03.02.01.02.00.00.00',
  '05.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.01.00.00',
  '05.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.08.00.00',
  '06.01' : '06.0e.2b.34.01.01.01.02.07.02.01.03.03.03.00.00',
  '06.02' : '06.0e.2b.34.01.01.01.02.05.30.04.04.01.00.00.00',
  '08.01' : '06.0e.2b.34.01.01.01.01.05.30.04.01.00.00.00.00',
  '09.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.0a.00.00',
  '0b.01' : '06.0e.2b.34.01.01.01.02.05.30.05.06.00.00.00.00',
  '0b.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.02.00.00',
  '0b.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.0a.00.00',
  '0b.04' : '06.0e.2b.34.01.01.01.02.05.30.05.0c.00.00.00.00',
  '0b.05' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.06.00.00',
  '0c.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.07.00.00',
  '0d.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.07.00.00',
  '0d.02' : '06.0e.2b.34.01.01.01.02.05.40.10.01.02.00.00.00',
  '0d.03' : '06.0e.2b.34.01.01.01.02.05.40.10.01.01.00.00.00',
  '0d.04' : '06.0e.2b.34.01.01.01.02.05.40.10.01.03.00.00.00',
  '0e.01' : '06.0e.2b.34.01.01.01.02.06.01.01.03.03.00.00.00',
  '0e.02' : '06.0e.2b.34.01.01.01.02.06.01.01.03.04.00.00.00',
  '0f.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.09.00.00',
  '0f.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.08.00.00',
  '10.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.09.00.00',
  '11.01' : '06.0e.2b.34.01.01.01.02.06.01.01.03.01.00.00.00',
  '11.02' : '06.0e.2b.34.01.01.01.02.06.01.01.03.02.00.00.00',
  '11.03' : '06.0e.2b.34.01.01.01.07.06.01.01.03.07.00.00.00',
  '11.04' : '06.0e.2b.34.01.01.01.08.06.01.01.03.08.00.00.00',
  '12.01' : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.04.00.00',
  '12.02' : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.05.02.00',
  '12.03' : '06.0e.2b.34.01.01.01.01.05.30.05.01.00.00.00.00',
  '12.04' : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.05.03.00',
  '12.05' : '06.0e.2b.34.01.01.01.01.05.30.05.02.00.00.00.00',
  '14.01' : '06.0e.2b.34.01.01.01.02.05.30.06.01.01.00.00.00',
  '14.02' : '06.0e.2b.34.01.01.01.02.05.30.06.02.01.00.00.00',
  '15.01' : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.05.00.00',
  '15.02' : '06.0e.2b.34.01.01.01.02.04.04.01.01.02.06.00.00',
  '15.03' : '06.0e.2b.34.01.01.01.01.04.04.01.01.05.00.00.00',
  '16.01' : '06.0e.2b.34.01.01.01.02.04.04.01.01.02.01.00.00',
  '16.02' : '06.0e.2b.34.01.01.01.02.04.07.03.00.00.00.00.00',
  '16.03' : '06.0e.2b.34.01.01.01.01.04.04.02.01.00.00.00.00',
  '17.01' : '06.0e.2b.34.01.01.01.01.04.04.01.01.04.00.00.00',
  '18.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.05.00.00',
  '18.02' : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.06.00.00',
  '19.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.01.00.00',
  '19.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.02.00.00',
  '1a.02' : '06.0e.2b.34.01.01.01.02.05.30.05.0d.00.00.00.00',
  '1a.03' : '06.0e.2b.34.01.01.01.02.07.02.01.03.10.02.01.00',
  '1a.04' : '06.0e.2b.34.01.01.01.02.05.30.05.08.00.00.00.00',
  '1b.01' : '06.0e.2b.34.01.01.01.02.01.01.15.03.00.00.00.00',
  '1b.02' : '06.0e.2b.34.01.01.01.02.01.07.01.02.03.01.00.00',
  '1b.03' : '06.0e.2b.34.01.01.01.02.03.02.03.01.02.01.00.00',
  '1e.01' : '06.0e.2b.34.01.01.01.02.05.30.05.09.00.00.00.00',
  '1e.02' : '06.0e.2b.34.01.01.01.01.05.30.05.03.00.00.00.00',
  '1e.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.04.01.00.00',
  '1e.06' : '06.0e.2b.34.01.01.01.02.05.30.05.0a.00.00.00.00',
  '1e.07' : '06.0e.2b.34.01.01.01.01.05.30.05.04.00.00.00.00',
  '1e.08' : '06.0e.2b.34.01.01.01.01.05.30.05.05.00.00.00.00',
  '1e.09' : '06.0e.2b.34.01.01.01.02.06.01.01.04.03.02.00.00',
  '1f.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.06.00.00',
  '1f.03' : '06.0e.2b.34.01.01.01.02.05.30.05.0b.01.00.00.00',
  '22.03' : '06.0e.2b.34.01.01.01.02.05.20.09.01.00.00.00.00',
  '22.04' : '06.0e.2b.34.01.01.01.02.03.03.03.01.03.00.00.00',
  '22.05' : '06.0e.2b.34.01.01.01.02.03.03.03.01.02.01.00.00',
  '22.06' : '06.0e.2b.34.01.01.01.02.01.0a.01.01.01.01.00.00',
  '22.07' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.0b.00.00',
  '22.08' : '06.0e.2b.34.01.01.01.02.01.0a.01.01.03.00.00.00',
  '22.09' : '06.0e.2b.34.01.01.01.02.05.20.09.02.00.00.00.00',
  '22.0a' : '06.0e.2b.34.01.01.01.02.05.20.09.03.00.00.00.00',
  '22.0b' : '06.0e.2b.34.01.01.01.02.05.20.09.04.00.00.00.00',
  '22.0c' : '06.0e.2b.34.01.01.01.02.05.20.09.05.00.00.00.00',
  '22.0d' : '06.0e.2b.34.01.01.01.02.05.20.09.06.00.00.00.00',
  '22.0e' : '06.0e.2b.34.01.01.01.02.05.20.09.07.00.00.00.00',
  '22.0f' : '06.0e.2b.34.01.01.01.02.05.20.09.08.00.00.00.00',
  '22.10' : '06.0e.2b.34.01.01.01.02.05.20.09.09.00.00.00.00',
  '22.11' : '06.0e.2b.34.01.01.01.02.05.20.09.0a.00.00.00.00',
  '22.12' : '06.0e.2b.34.01.01.01.02.05.20.09.0b.00.00.00.00',
  '22.13' : '06.0e.2b.34.01.01.01.02.05.20.09.0c.00.00.00.00',
  '22.14' : '06.0e.2b.34.01.01.01.02.05.20.09.0d.00.00.00.00',
  '22.15' : '06.0e.2b.34.01.01.01.02.05.20.09.0e.00.00.00.00',
  '22.16' : '06.0e.2b.34.01.01.01.02.05.20.09.0f.00.00.00.00',
  '23.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.07.00.00',
  '23.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.03.01.00.00',
  '24.01' : '06.0e.2b.34.01.01.01.01.03.01.02.01.03.00.00.00',
  '26.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.03.00.00',
  '26.04' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.04.00.00',
  '26.05' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.05.00.00',
  '26.06' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.06.00.00',
  '26.07' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.07.00.00',
  '26.08' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.08.00.00',
  '26.09' : '06.0e.2b.34.01.01.01.02.06.01.01.04.05.09.00.00',
  '26.0a' : '06.0e.2b.34.01.01.01.07.06.01.01.04.05.0a.00.00',
  '26.0b' : '06.0e.2b.34.01.01.01.07.06.01.01.04.05.0b.00.00',
  '27.01' : '06.0e.2b.34.01.01.01.02.06.01.01.06.01.00.00.00',
  '27.02' : '06.0e.2b.34.01.01.01.02.04.07.02.00.00.00.00.00',
  '2b.01' : '06.0e.2b.34.01.01.01.02.06.01.01.02.01.00.00.00',
  '2f.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.03.00.00',
  '30.01' : '06.0e.2b.34.01.01.01.01.04.06.01.01.00.00.00.00',
  '30.02' : '06.0e.2b.34.01.01.01.01.04.06.01.02.00.00.00.00',
  '30.04' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.02.00.00',
  '30.05' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.03.00.00',
  '30.06' : '06.0e.2b.34.01.01.01.05.06.01.01.03.05.00.00.00',
  '31.01' : '06.0e.2b.34.01.01.01.02.03.03.03.02.02.00.00.00',
  '32.01' : '06.0e.2b.34.01.01.01.02.03.03.03.02.02.00.00.00',
  '32.02' : '06.0e.2b.34.01.01.01.01.04.01.05.02.01.00.00.00',
  '32.03' : '06.0e.2b.34.01.01.01.01.04.01.05.02.02.00.00.00',
  '32.04' : '06.0e.2b.34.01.01.01.01.04.01.05.01.07.00.00.00',
  '32.05' : '06.0e.2b.34.01.01.01.01.04.01.05.01.08.00.00.00',
  '32.06' : '06.0e.2b.34.01.01.01.01.04.01.05.01.09.00.00.00',
  '32.07' : '06.0e.2b.34.01.01.01.01.04.01.05.01.0a.00.00.00',
  '32.08' : '06.0e.2b.34.01.01.01.01.04.01.05.01.0b.00.00.00',
  '32.09' : '06.0e.2b.34.01.01.01.01.04.01.05.01.0c.00.00.00',
  '32.0a' : '06.0e.2b.34.01.01.01.01.04.01.05.01.0d.00.00.00',
  '32.0b' : '06.0e.2b.34.01.01.01.01.04.01.05.01.0e.00.00.00',
  '32.0c' : '06.0e.2b.34.01.01.01.01.04.01.03.01.04.00.00.00',
  '32.0d' : '06.0e.2b.34.01.01.01.02.04.01.03.02.05.00.00.00',
  '32.0e' : '06.0e.2b.34.01.01.01.01.04.01.01.01.01.00.00.00',
  '32.0f' : '06.0e.2b.34.01.01.01.02.05.20.01.02.00.00.00.00',
  '32.10' : '06.0e.2b.34.01.01.01.02.04.01.02.01.01.01.02.00',
  '32.11' : '06.0e.2b.34.01.01.01.02.04.18.01.01.00.00.00.00',
  '32.12' : '06.0e.2b.34.01.01.01.02.04.01.03.01.06.00.00.00',
  '32.13' : '06.0e.2b.34.01.01.01.02.04.18.01.02.00.00.00.00',
  '32.14' : '06.0e.2b.34.01.01.01.02.04.18.01.03.00.00.00.00',
  '32.15' : '06.0e.2b.34.01.01.01.05.04.05.01.13.00.00.00.00',
  '32.16' : '06.0e.2b.34.01.01.01.05.04.01.03.02.08.00.00.00',
  '32.17' : '06.0e.2b.34.01.01.01.05.04.01.03.02.07.00.00.00',
  '32.18' : '06.0e.2b.34.01.01.01.05.04.01.03.02.09.00.00.00',
  '32.19' : '06.0e.2b.34.01.01.01.09.04.01.02.01.01.06.01.00',
  '32.1a' : '06.0e.2b.34.01.01.01.02.04.01.02.01.01.03.01.00',
  '33.01' : '06.0e.2b.34.01.01.01.02.04.01.05.03.0a.00.00.00',
  '33.02' : '06.0e.2b.34.01.01.01.01.04.01.05.01.05.00.00.00',
  '33.03' : '06.0e.2b.34.01.01.01.01.04.01.05.01.06.00.00.00',
  '33.04' : '06.0e.2b.34.01.01.01.01.04.01.05.03.03.00.00.00',
  '33.05' : '06.0e.2b.34.01.01.01.01.04.01.05.03.04.00.00.00',
  '33.06' : '06.0e.2b.34.01.01.01.02.04.01.05.03.05.00.00.00',
  '33.07' : '06.0e.2b.34.01.01.01.02.04.18.01.04.00.00.00.00',
  '33.08' : '06.0e.2b.34.01.01.01.02.04.01.05.01.10.00.00.00',
  '33.09' : '06.0e.2b.34.01.01.01.02.04.01.05.03.07.00.00.00',
  '33.0b' : '06.0e.2b.34.01.01.01.05.03.01.02.01.0a.00.00.00',
  '34.01' : '06.0e.2b.34.01.01.01.02.04.01.05.03.06.00.00.00',
  '34.03' : '06.0e.2b.34.01.01.01.02.04.01.05.03.08.00.00.00',
  '34.04' : '06.0e.2b.34.01.01.01.02.04.01.05.03.09.00.00.00',
  '34.05' : '06.0e.2b.34.01.01.01.05.04.01.04.04.01.00.00.00',
  '34.06' : '06.0e.2b.34.01.01.01.05.04.01.05.03.0b.00.00.00',
  '34.07' : '06.0e.2b.34.01.01.01.05.04.01.05.03.0c.00.00.00',
  '34.08' : '06.0e.2b.34.01.01.01.05.04.01.05.03.0d.00.00.00',
  '34.09' : '06.0e.2b.34.01.01.01.05.04.01.05.03.0e.00.00.00',
  '35.01' : '06.0e.2b.34.01.01.01.05.04.04.01.02.01.00.00.00',
  '35.02' : '06.0e.2b.34.01.01.01.05.04.04.01.02.02.00.00.00',
  '35.03' : '06.0e.2b.34.01.01.01.05.04.04.01.02.03.00.00.00',
  '35.04' : '06.0e.2b.34.01.01.01.05.04.04.01.02.04.00.00.00',
  '37.01' : '06.0e.2b.34.01.01.01.02.05.02.01.03.01.01.00.00',
  '37.02' : '06.0e.2b.34.01.01.01.01.06.08.02.01.00.00.00.00',
  '37.03' : '06.0e.2b.34.01.01.01.01.04.01.03.02.03.00.00.00',
  '37.04' : '06.0e.2b.34.01.01.01.01.04.01.03.02.04.00.00.00',
  '37.05' : '06.0e.2b.34.01.01.01.02.05.02.01.03.01.02.00.00',
  '37.06' : '06.0e.2b.34.01.01.01.02.03.03.03.02.03.00.00.00',
  '38.01' : '06.0e.2b.34.01.01.01.02.03.03.03.02.01.00.00.00',
  '39.01' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.08.00.00',
  '39.02' : '06.0e.2b.34.01.01.01.02.04.01.08.02.03.00.00.00',
  '39.03' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.03.00.00',
  '39.04' : '06.0e.2b.34.01.01.01.02.04.10.01.03.02.03.00.00',
  '39.05' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.06.01.00',
  '39.06' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.05.01.00',
  '39.07' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.04.01.00',
  '39.08' : '06.0e.2b.34.01.01.01.02.04.10.01.03.01.07.01.00',
  '3a.01' : '06.0e.2b.34.01.01.01.02.04.10.01.01.01.01.00.00',
  '3a.02' : '06.0e.2b.34.01.01.01.02.04.01.04.01.01.00.00.00',
  '3a.03' : '06.0e.2b.34.01.01.01.02.0d.01.01.01.01.01.01.00',
  '3a.04' : '06.0e.2b.34.01.01.01.02.04.10.01.01.03.00.00.00',
  '3a.05' : '06.0e.2b.34.01.01.01.02.04.10.01.01.04.01.00.00',
  '3a.06' : '06.0e.2b.34.01.01.01.02.04.10.01.01.02.01.00.00',
  '3a.07' : '06.0e.2b.34.01.01.01.02.04.10.01.01.06.01.00.00',
  '3a.08' : '06.0e.2b.34.01.01.01.02.04.10.01.01.05.01.00.00',
  '3b.01' : '06.0e.2b.34.01.01.01.01.03.01.02.01.02.00.00.00',
  '3b.02' : '06.0e.2b.34.01.01.01.02.07.02.01.10.02.04.00.00',
  '3b.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.01.00.00',
  '3b.04' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.02.00.00',
  '3b.05' : '06.0e.2b.34.01.01.01.02.03.01.02.01.05.00.00.00',
  '3b.06' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.04.00.00',
  '3b.07' : '06.0e.2b.34.01.01.01.02.03.01.02.01.04.00.00.00',
  '3b.08' : '06.0e.2b.34.01.01.01.04.06.01.01.04.01.08.00.00',
  '3b.09' : '06.0e.2b.34.01.01.01.05.01.02.02.03.00.00.00.00',
  '3b.0a' : '06.0e.2b.34.01.01.01.05.01.02.02.10.02.01.00.00',
  '3b.0b' : '06.0e.2b.34.01.01.01.05.01.02.02.10.02.02.00.00',
  '3c.01' : '06.0e.2b.34.01.01.01.02.05.20.07.01.02.01.00.00',
  '3c.02' : '06.0e.2b.34.01.01.01.02.05.20.07.01.03.01.00.00',
  '3c.03' : '06.0e.2b.34.01.01.01.02.05.20.07.01.04.00.00.00',
  '3c.04' : '06.0e.2b.34.01.01.01.02.05.20.07.01.05.01.00.00',
  '3c.05' : '06.0e.2b.34.01.01.01.02.05.20.07.01.07.00.00.00',
  '3c.06' : '06.0e.2b.34.01.01.01.02.07.02.01.10.02.03.00.00',
  '3c.07' : '06.0e.2b.34.01.01.01.02.05.20.07.01.0a.00.00.00',
  '3c.08' : '06.0e.2b.34.01.01.01.02.05.20.07.01.06.01.00.00',
  '3c.09' : '06.0e.2b.34.01.01.01.02.05.20.07.01.01.00.00.00',
  '3c.0a' : '06.0e.2b.34.01.01.01.01.01.01.15.02.00.00.00.00',
  '3d.01' : '06.0e.2b.34.01.01.01.04.04.02.03.03.04.00.00.00',
  '3d.02' : '06.0e.2b.34.01.01.01.04.04.02.03.01.04.00.00.00',
  '3d.03' : '06.0e.2b.34.01.01.01.05.04.02.03.01.01.01.00.00',
  '3d.04' : '06.0e.2b.34.01.01.01.01.04.02.01.01.03.00.00.00',
  '3d.05' : '06.0e.2b.34.01.01.01.01.04.02.01.01.01.00.00.00',
  '3d.06' : '06.0e.2b.34.01.01.01.02.04.02.04.02.00.00.00.00',
  '3d.07' : '06.0e.2b.34.01.01.01.05.04.02.01.01.04.00.00.00',
  '3d.08' : '06.0e.2b.34.01.01.01.05.04.02.05.01.01.00.00.00',
  '3d.09' : '06.0e.2b.34.01.01.01.05.04.02.03.03.05.00.00.00',
  '3d.0a' : '06.0e.2b.34.01.01.01.05.04.02.03.02.01.00.00.00',
  '3d.0b' : '06.0e.2b.34.01.01.01.05.04.02.03.02.02.00.00.00',
  '3d.0c' : '06.0e.2b.34.01.01.01.05.04.02.07.01.00.00.00.00',
  '3d.0d' : '06.0e.2b.34.01.01.01.05.04.02.05.01.06.00.00.00',
  '3d.0f' : '06.0e.2b.34.01.01.01.05.04.02.03.02.03.00.00.00',
  '3d.10' : '06.0e.2b.34.01.01.01.05.04.02.05.01.02.00.00.00',
  '3d.11' : '06.0e.2b.34.01.01.01.05.04.02.05.01.03.00.00.00',
  '3d.12' : '06.0e.2b.34.01.01.01.05.04.02.05.01.04.00.00.00',
  '3d.13' : '06.0e.2b.34.01.01.01.05.04.02.05.01.05.00.00.00',
  '3d.15' : '06.0e.2b.34.01.01.01.05.04.02.03.02.05.00.00.00',
  '3d.16' : '06.0e.2b.34.01.01.01.05.04.02.03.02.06.00.00.00',
  '3d.21' : '06.0e.2b.34.01.01.01.05.04.02.05.02.01.01.00.00',
  '3d.22' : '06.0e.2b.34.01.01.01.05.04.02.05.02.02.01.00.00',
  '3d.23' : '06.0e.2b.34.01.01.01.05.04.02.05.02.03.01.00.00',
  '3d.24' : '06.0e.2b.34.01.01.01.05.04.02.05.02.04.01.00.00',
  '3d.25' : '06.0e.2b.34.01.01.01.05.04.02.05.02.05.01.00.00',
  '3d.26' : '06.0e.2b.34.01.01.01.05.04.02.05.02.06.01.00.00',
  '3d.27' : '06.0e.2b.34.01.01.01.05.04.02.05.02.07.01.00.00',
  '3d.28' : '06.0e.2b.34.01.01.01.05.04.02.05.02.08.01.00.00',
  '3d.29' : '06.0e.2b.34.01.01.01.08.04.02.03.01.06.00.00.00',
  '3d.2a' : '06.0e.2b.34.01.01.01.08.04.02.03.01.07.00.00.00',
  '3d.2b' : '06.0e.2b.34.01.01.01.08.04.02.03.01.08.00.00.00',
  '3d.2c' : '06.0e.2b.34.01.01.01.08.04.02.03.01.09.00.00.00',
  '3d.2d' : '06.0e.2b.34.01.01.01.08.04.02.03.01.0a.00.00.00',
  '3d.2e' : '06.0e.2b.34.01.01.01.08.04.02.03.01.0b.00.00.00',
  '3d.2f' : '06.0e.2b.34.01.01.01.08.04.02.03.01.0c.00.00.00',
  '3d.30' : '06.0e.2b.34.01.01.01.08.04.02.03.01.0d.00.00.00',
  '3d.31' : '06.0e.2b.34.01.01.01.08.04.02.03.01.0e.00.00.00',
  '3d.32' : '06.0e.2b.34.01.01.01.07.04.02.01.01.05.00.00.00',
  '3d.33' : '06.0e.2b.34.01.01.01.08.06.01.01.04.06.0f.00.00',
  '3e.01' : '06.0e.2b.34.01.01.01.03.04.03.03.02.00.00.00.00',
  '3f.01' : '06.0e.2b.34.01.01.01.04.06.01.01.04.06.0b.00.00',
  '3f.05' : '06.0e.2b.34.01.01.01.04.04.06.02.01.00.00.00.00',
  '3f.06' : '06.0e.2b.34.01.01.01.04.01.03.04.05.00.00.00.00',
  '3f.07' : '06.0e.2b.34.01.01.01.04.01.03.04.04.00.00.00.00',
  '3f.08' : '06.0e.2b.34.01.01.01.04.04.04.04.01.01.00.00.00',
  '3f.09' : '06.0e.2b.34.01.01.01.05.04.04.04.01.06.00.00.00',
  '3f.0a' : '06.0e.2b.34.01.01.01.05.04.04.04.02.05.00.00.00',
  '3f.0b' : '06.0e.2b.34.01.01.01.05.05.30.04.06.00.00.00.00',
  '3f.0c' : '06.0e.2b.34.01.01.01.05.07.02.01.03.01.0a.00.00',
  '3f.0d' : '06.0e.2b.34.01.01.01.05.07.02.02.01.01.02.00.00',
  '3f.0e' : '06.0e.2b.34.01.01.01.05.04.04.04.01.07.00.00.00',
  '3f.0f' : '06.0e.2b.34.01.01.01.0a.04.06.02.04.00.00.00.00',
  '3f.10' : '06.0e.2b.34.01.01.01.0a.04.06.02.05.00.00.00.00',
  '3f.11' : '06.0e.2b.34.01.01.01.0e.04.04.05.01.00.00.00.00',
  '3f.12' : '06.0e.2b.34.01.01.01.0e.04.06.02.06.00.00.00.00',
  '3f.13' : '06.0e.2b.34.01.01.01.0e.04.04.05.02.00.00.00.00',
  '40.01' : '06.0e.2b.34.01.01.01.01.01.02.01.01.01.00.00.00',
  '41.01' : '06.0e.2b.34.01.01.01.02.01.04.01.02.01.00.00.00',
  '44.01' : '06.0e.2b.34.01.01.01.01.01.01.15.10.00.00.00.00',
  '44.02' : '06.0e.2b.34.01.01.01.01.01.03.03.02.01.00.00.00',
  '44.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.05.00.00',
  '44.04' : '06.0e.2b.34.01.01.01.02.07.02.01.10.02.05.00.00',
  '44.05' : '06.0e.2b.34.01.01.01.02.07.02.01.10.01.03.00.00',
  '44.06' : '06.0e.2b.34.01.01.01.02.03.02.01.02.0c.00.00.00',
  '44.07' : '06.0e.2b.34.01.01.01.02.03.01.02.10.03.00.00.00',
  '44.08' : '06.0e.2b.34.01.01.01.07.05.01.01.08.00.00.00.00',
  '44.09' : '06.0e.2b.34.01.01.01.07.03.01.02.10.07.00.00.00',
  '45.01' : '06.0e.2b.34.01.01.01.02.07.02.02.01.01.05.01.00',
  '45.02' : '06.0e.2b.34.01.01.01.01.05.30.02.01.00.00.00.00',
  '45.03' : '06.0e.2b.34.01.01.01.02.05.30.04.03.00.00.00.00',
  '45.04' : '06.0e.2b.34.01.01.01.08.06.01.01.04.01.0a.00.00',
  '47.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.03.00.00',
  '48.01' : '06.0e.2b.34.01.01.01.02.01.07.01.01.00.00.00.00',
  '48.02' : '06.0e.2b.34.01.01.01.02.01.07.01.02.01.00.00.00',
  '48.03' : '06.0e.2b.34.01.01.01.02.06.01.01.04.02.04.00.00',
  '48.04' : '06.0e.2b.34.01.01.01.02.01.04.01.03.00.00.00.00',
  '49.01' : '06.0e.2b.34.01.01.01.02.05.30.04.02.00.00.00.00',
  '49.02' : '06.0e.2b.34.01.01.01.05.07.02.01.03.01.0b.00.00',
  '4b.01' : '06.0e.2b.34.01.01.01.02.05.30.04.05.00.00.00.00',
  '4b.02' : '06.0e.2b.34.01.01.01.02.07.02.01.03.01.03.00.00',
  '4b.03' : '06.0e.2b.34.01.01.01.07.07.02.01.03.01.0c.00.00',
  '4b.04' : '06.0e.2b.34.01.01.01.07.07.02.01.03.02.03.00.00',
  '4b.05' : '06.0e.2b.34.01.01.01.07.07.02.01.03.01.0d.00.00',
  '4c.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.04.00.00',
  '4c.11' : '06.0e.2b.34.01.01.01.07.06.01.01.04.03.05.00.00',
  '4d.01' : '06.0e.2b.34.01.01.01.02.05.30.05.07.00.00.00.00',
  '4d.11' : '06.0e.2b.34.01.01.01.07.06.01.01.04.03.04.00.00',
  '4d.12' : '06.0e.2b.34.01.01.01.07.06.01.01.04.01.09.00.00',
  '4e.01' : '06.0e.2b.34.01.01.01.02.06.01.01.04.01.05.00.00',
  '4e.02' : '06.0e.2b.34.01.01.01.02.06.01.01.04.06.06.00.00',
  '4e.11' : '06.0e.2b.34.01.01.01.07.04.09.02.01.00.00.00.00',
  '4e.12' : '06.0e.2b.34.01.01.01.08.04.09.03.00.00.00.00.00',
  '4f.01' : '06.0e.2b.34.01.01.01.08.04.06.08.02.00.00.00.00',
  '4f.02' : '06.0e.2b.34.01.01.01.08.04.06.09.03.00.00.00.00',
  '4f.03' : '06.0e.2b.34.01.01.01.08.04.07.04.00.00.00.00.00',
  '50.01' : '06.0e.2b.34.01.01.01.02.03.02.01.02.09.01.00.00',
  '50.03' : '06.0e.2b.34.01.01.01.02.03.02.01.02.0a.01.00.00',
  '51.01' : '06.0e.2b.34.01.01.01.02.03.01.02.10.02.00.00.00',
  '52.12' : '06.0e.2b.34.01.01.01.08.04.09.04.01.00.00.00.00',
  '54.01' : '06.0e.2b.34.01.01.01.08.01.02.01.04.01.00.00.00',
  '54.02' : '06.0e.2b.34.01.01.01.08.01.02.01.06.01.00.00.00',
  '54.03' : '06.0e.2b.34.01.01.01.08.01.03.06.06.01.00.00.00',
  '55.01' : '06.0e.2b.34.01.01.01.08.01.03.06.04.01.00.00.00',
  '56.01' : '06.0e.2b.34.01.01.01.09.01.03.04.06.00.00.00.00',
  '56.02' : '06.0e.2b.34.01.01.01.09.01.03.04.07.00.00.00.00',
  '57.01' : '06.0e.2b.34.01.01.01.09.07.02.05.01.00.00.00.00',
  '57.02' : '06.0e.2b.34.01.01.01.09.07.02.05.03.00.00.00.00',
  '57.03' : '06.0e.2b.34.01.01.01.09.07.02.05.02.00.00.00.00',
  '58.01' : '06.0e.2b.34.01.01.01.09.06.01.01.03.09.00.00.00',
  '58.02' : '06.0e.2b.34.01.01.01.09.06.01.01.03.0a.00.00.00',
  '58.03' : '06.0e.2b.34.01.01.01.09.06.01.01.03.0b.00.00.00',
  '58.04' : '06.0e.2b.34.01.01.01.09.06.01.01.03.0c.00.00.00',
  '61.01' : '06.0e.2b.34.01.01.01.05.06.01.01.04.02.0c.00.00',
  '61.02' : '06.0e.2b.34.01.01.01.04.01.07.01.05.00.00.00.00',
  '61.03' : '06.0e.2b.34.01.01.01.05.01.07.01.06.00.00.00.00',
};
